<template>
  <div class="map-display-panel">
    <h5>Farm Map</h5>
    <div class="map-container">
      <div id="satelliteImageryMap" style="height: 600px; width: 100%; border-radius: 4px; border: 1px solid #ddd; position: relative;">
        <!-- Map Loading Spinner -->
        <div v-if="mapLoading" class="map-spinner">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading map...</span>
          </div>
          <p class="mt-2 mb-0 text-muted">Loading farm map...</p>
        </div>
        
        <!-- Tile Loading Spinner -->
        <div v-if="tileLoading" class="map-spinner tile-loading">
          <div class="spinner-border text-success" role="status">
            <span class="sr-only">Loading satellite imagery...</span>
          </div>
          <p class="mt-2 mb-0 text-muted">Loading satellite imagery...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MapDisplayPanel',
  props: {
    map: {
      type: Object,
      default: null
    },
    mapLoading: {
      type: Boolean,
      default: false
    },
    tileLoading: {
      type: Boolean,
      default: false
    },
    blocksGeoJson: {
      type: Object,
      default: null
    },
    selectedBlock: {
      type: Object,
      default: null
    },
    latestImagery: {
      type: Object,
      default: null
    },
    satelliteLayerAdded: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    map(newMap) {
      if (newMap) {
        this.$emit('mapReady', newMap)
      }
    }
  }
}
</script>

<style scoped>
.map-container {
  border: 1px solid #dee2e6;
  border-radius: 0.25rem;
  overflow: hidden;
}

.map-spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  background-color: rgba(255, 255, 255, 0.9);
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
}

.tile-loading {
  background-color: rgba(255, 255, 255, 0.95);
  border: 2px solid #28a745;
}

#satelliteImageryMap {
  background-color: #f8f9fa;
}
</style>
